@let apartment = apartment$ | async;
@let relevantApartmentsInputValue = relevantApartmentsInput();
@if (apartment && relevantApartmentsInputValue) {
  <article homeyApartmentDetailPageContent
    [apartment]="apartment"
    [householdSize]="1"
    [relevantApartmentsInput]="relevantApartmentsInputValue"
    [showH2]="true"
    [showEligibilityCarouselCta]="showCarouselEligibilityCta()"
  >
    <ng-container apartmentUnits>
      @if (apartment.type === 'regular') {
        @let eligibleResult = apartment | relevantAdvertisements: relevantApartmentsInputValue;
        @if (eligibleResult.status === 'eligible') {
          <homey-apartment-detail-info-item

            icon="pi-warehouse"
            title="Eligible units">
              <homey-regular-eligible-units [eligibleUnits]="eligibleResult.advertisements" />
          </homey-apartment-detail-info-item>
        }
      }
      @else {
        @let eligibleResult = apartment | relevantAdvertisements: relevantApartmentsInputValue;
        @if (eligibleResult.status === 'eligible') {
          <homey-apartment-detail-info-item
            icon="pi-warehouse"
            title="Eligible units">
            <homey-senior-eligible-units [eligibleUnits]="eligibleResult.advertisements" />
          </homey-apartment-detail-info-item>
        }
    }
    </ng-container>
  </article>
  @if (signupToApplyRoute()) {
    <homey-sticky-footer>
      <div class="py-4">
        <a pButton class="w-full block" severity="primary" [routerLink]="signupToApplyRoute()"><span pButtonLabel>Sign up to apply</span></a>
      </div>
    </homey-sticky-footer>
  }
}
